import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorReturnHistoryList = () => {
  const returnHistoryList = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/transaction-retur-header/history', payload, (response) => {
      if (response.status_code === 200) {
        if (response.data) {
          callback(response.data)
        }
      }
      loading(false)
    })
  }, [])
  return { returnHistoryList }
}

export default InteractorReturnHistoryList
